import Vue from 'vue'
Vue.filter('numberFormat', (value, flag = true) => {
    if(!flag) return '******'
    if(!value && value !== 0) return '0.00'
    let val = Number(value).toFixed(2)
    return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
})


// WEBPACK FOOTER //
// ./src/filter/index.js